<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人列表</el-breadcrumb-item>
        <el-breadcrumb-item>任务列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
            <el-col  >
                <!-- <el-button type="primary" @click="openAddJobPlanDialogVisible()">添加任务</el-button> -->
                <!-- <el-button type="primary" @click="executeTask()">更新任务</el-button> -->
                <el-button type="primary" style="float:right" @click="returnTaskMap()">返回上一页</el-button>
            </el-col> 
        </el-row>
        <!-- 用户列表区域 -->
        <el-table ref="multipleTable" :data="jobPlanList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" ></el-table-column>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器编号" prop="robotNo" width="300"></el-table-column>
            <el-table-column label="计划名称" prop="jobName" width="250"></el-table-column>
            <el-table-column label="任务类型" prop="type" width="100">
                 <template slot-scope="scope">
                    <span v-if="scope.row.type==='2'"  >
                        定时
                    </span>
                    <span v-if="scope.row.type==='1'" >
                        循环
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="执行周期" prop="week" width="250">
                <template slot-scope="scope">
                    <span v-if="scope.row.week.includes('1')"  >
                       周一
                    </span>
                    <span v-if="scope.row.week.includes('2')" >
                       周二
                    </span>
                    <span v-if="scope.row.week.includes('3')"  >
                       周三
                    </span>
                    <span v-if="scope.row.week.includes('4')" >
                      周四
                    </span>
                    <span v-if="scope.row.week.includes('5')"  >
                        周五
                    </span>
                    <span v-if="scope.row.week.includes('6')" >
                        周六
                    </span>
                    <span v-if="scope.row.week.includes('7')"  >
                        周日
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="执行计划时间" prop="createTime" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.type=='1'"  >
                            {{scope.row.startTime}}~{{scope.row.endTime}}
                    </span> 
                    <span v-if="scope.row.type=='2'"  >
                            {{scope.row.time}}
                    </span> 
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="200"></el-table-column>
            <el-table-column label="操作" prop="" width="200">
                <template slot-scope="scope">
                     <!-- 删除按钮 -->
                    <!-- <el-tooltip effect="dark" content="修改" placement="top" :enterable="false"  >  
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="editById(scope.row.id)"></el-button>
                    </el-tooltip> -->
                      <!-- 删除按钮 -->
                      <el-tooltip effect="dark" content="查看详情" placement="top" :enterable="false"  >  
                        <el-button type="primary" icon="el-icon-view" size="mini" @click="editById(scope.row.id)"></el-button>
                    </el-tooltip>
                    <!-- 删除按钮 -->
                    <!-- <el-tooltip effect="dark" content="删除" placement="top" :enterable="false"  >  
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteById(scope.row.id)"></el-button>
                    </el-tooltip> -->
                </template>
            </el-table-column>
        </el-table>
         <!-- 添加计划 -->
        <el-dialog  title="添加工作计划" :visible.sync="addJobPlanDialogVisible"   width="80%"  @close="addJobPlanDialogClose">
            <!--地图信息展示-->
            <el-row :gutter='20'>
                <el-col :span="12">
                    <canvas id="addmycanvas" class="mycanvasDiv" alt="" style="margin-top: 20px;height: auto;width: 100%;" />
                </el-col>
                <el-col :span="12">
                    <el-form :inline="true" :model="addJobPlan"  ref="addJobPlanRef"   id="selectForm">
                    <el-row >
                        <el-row >
                            <el-form-item label="计划名称:"  label-width="100px" >
                                <el-input v-model="addJobPlan.jobName" placeholder="任务名称" class="m-l-10 ell-input" ></el-input>
                            </el-form-item>
                            
                        </el-row>
                    </el-row>
                    <el-row >
                        <el-row >
                            <el-form-item label="执行类型:" label-width="100px" >
                                <el-select v-model="addJobPlan.type" placeholder="执行类型" style="margin-right: 40px" class="m-l-10 els-input" @change="changeJobPlanType">
                                    <el-option label="循环计划" value="1"></el-option>
                                    <el-option label="定时计划" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="消杀类型:" label-width="100px" >
                                <el-select v-model="addJobPlan.modeType" placeholder="消杀类型" style="margin-right: 10px" class="m-l-10 el-input" >
                                    <el-option label="定点消杀" value="0"></el-option>
                                    <el-option label="全程消杀" value="1"></el-option>
                                    <el-option label="演示模式" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                    </el-row>
                    <!--循环-->
                    <el-row v-if="addJobPlan.type=='1'">
                        <el-row  >
                            <el-form-item label="起始时间:" label-width="100px" >
                                <el-time-picker v-model="addJobPlan.startAndend" is-range range-separator="至" start-placeholder="开始时间" 
                                end-placeholder="结束时间" placeholder="选择时间范围" value-format="HH:mm" format='HH:mm' class="m-l-10"/>
                            </el-form-item>
                         </el-row>
                         <el-row  >
                            <el-form-item  label="间隔时长:" label-width="100px" >
                                <el-select v-model="addJobPlan.interval" placeholder="请选择时长" style="width:60%" class="m-l-10">
                                    <el-option v-for="item in addJobPlan.JobPlanSplitTime" :key="item.timeId" :label="item.label" :value="item.timeId" :disabled="item.disabled"  />
                                </el-select>
                            </el-form-item>
                          </el-row>
                    </el-row>
                    <!--定时-->
                    <el-row v-if="addJobPlan.type=='2'">
                        <el-row  >
                            <el-col :span="16">
                                <el-form-item  label="选择时间:" label-width="100px">
                                    <el-time-picker v-model="addJobPlan.selectValueStr" type="fixed-time" placeholder="选择时间" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" value-format="HH:mm" format='HH:mm' style="width:100%" class="m-l-10" /> 
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" >
                                    <el-button type="primary" style="width:80px" vertical-align="middle" @click="addTimeClick()">添加</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item  label="任务时间:" label-width="100px">
                                    <el-input v-model="addJobPlan.time" type="textarea" style="width:125%" :disabled="true" class="m-l-10" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                    <el-button type="primary" style="width:80px" vertical-align="middle" @click="reduceTimeClick()">删除</el-button>
                            </el-col>
                            
                         </el-row>
                    </el-row>
                    <!--执行周期-->
                    <el-row>
                        <el-row>
                                <el-checkbox :indeterminate="addJobPlan.isIndeterminate" v-model="addJobPlan.checkAll" @change="handleCheckAllChange" ><span style="font-size:18px;">全选</span></el-checkbox>
                                <div style="margin: 15px 0;"></div>
                                <el-checkbox-group v-model="addJobPlan.checkedWeekes" @change="handleCheckedcheckChange"  style="font-size:18px;">
                                    <el-checkbox v-for="item in addJobPlan.labels" :label="item.value" :key="item.value"  >{{item.label}}</el-checkbox>
                                </el-checkbox-group>
                        </el-row>
                    </el-row>
                    <!--选择点-->
                    <el-row >
                        <div style="border-style:solid;border-width:1px;border-color:black;min-height:200px;margin-top: 20px">
                            <span style="font-size:20px;color:blue;">点位信息编辑</span>
                            <el-row>
                                <el-col :span="12" > 
                                    <el-form-item label="工作类型:" label-width="100px" style="margin-top: 20px;" v-if="addJobPlan.modeType ==='0'" >
                                        <el-select v-model="addJobPlan.jobDetail.type" placeholder="请选择"  class="m-l-10 el-input" >
                                            <el-option label="消杀" value="1"></el-option>
                                            <el-option label="行走" value="0"></el-option>
                                            <el-option label="语音播报" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="工作类型:" label-width="100px" style="margin-top: 20px;"  v-if="addJobPlan.modeType !=='0'">
                                        <span style="font-size:18px;color:black;">行走</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                <el-form-item  label="工作时长:" label-width="100px" style="margin-top: 20px"  >
                                    <el-select v-model="addJobPlan.jobDetail.time" placeholder="请选择时长" class="m-l-10 el-input">
                                        <el-option v-for="item in addJobPlan.jobDetailSplitTime" :key="item.timeId" :label="item.label" :value="item.timeId" :disabled="item.disabled"  />
                                    </el-select>
                                </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" > 
                                    <el-form-item  label="编号:" label-width="100px"  >  
                                        <el-select v-model="addJobPlan.jobDetail.goalId" placeholder="请选择点位" style="margin-right: 50px"  class="m-l-10 el-input" >
                                            <el-option v-for="item in goalList" :key="item.id" :label="item.id" :value="item.id" :disabled="item.disabled"  />
                                        </el-select>
                                    </el-form-item>          
                                    <!-- <el-input v-model="addJobPlan.jobDetail.goalId" disabled style="width:40%" class="m-l-10 "/> -->
                                </el-col>
                                <el-col :span="12"> 
                                    <el-form-item  label="信息:" label-width="100px"  >  
                                        <el-input v-model="addJobPlan.jobDetail.remarks"  style="width:100%" class="m-l-10 ell-input"/>
                                    </el-form-item>    
                                </el-col>
                                
                            </el-row>
                            <el-row>
                                <el-col :span="24" :push="16" > 
                                    <el-button type="primary"   @click="addJobDetail('add')" > 添加任务</el-button>
                                    <el-button type="primary"   @click="cleanJobDetail()">重置</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-row>
                    <!--任务明细表格-->
                    <el-row>
                        <el-table :data="addJobPlan.jobdetailList" height="250" border style="width: 100%"   stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
                                <el-table-column prop="goalId" label="点位编号" width="80"></el-table-column>
                                <el-table-column prop="type" label="工作类型" width="80"> 
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.type==='0'"  >
                                            行走
                                        </span>
                                        <span v-if="scope.row.type==='1'" >
                                            消杀
                                        </span>
                                        <span v-if="scope.row.type==='2'" >
                                            语音播报
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="time" label="工作时长" width="125">
                                     <template slot-scope="scope" >
                                        <el-input v-model="scope.row.time" style="width:100px" class="ellll-input" @input.native="onInput0_300" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="remarks" label="备注信息" width="300">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.remarks!=='null'"  >
                                          {{scope.row.remarks}}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" prop="" width="80">
                                    <template slot-scope="scope">
                                        <!-- 删除按钮 -->
                                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false"  >  
                                            <el-button type="danger" icon="el-icon-minus" size="mini" @click="deleteBygoalId(scope.row.goalId)"></el-button>
                                        </el-tooltip>
                                    </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addJobPlanDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addJobPlanDialogData()" >确 定</el-button>
            </span>
        </el-dialog>
        <!--编辑工作计划-->
        <el-dialog  title="编辑工作计划" :visible.sync="editJobPlanDialogVisible"   width="80%"   @close="editJobPlanDialogClose" disabled >
            <!--地图信息展示-->
            <el-row :gutter='20'>
                <el-col :span="12">
                    <canvas id="editmycanvas" class="mycanvasDiv" alt="" style="height: auto;width: 100%;"  />
                </el-col>
                <el-col :span="12">
                    <el-form :inline="true" :model="editJobPlan"  ref="addJobPlanRef"   id="selectForm">
                    <el-row >
                        <el-row >
                            <el-form-item label="计划名称:"  label-width="100px" >
                                <el-input v-model="editJobPlan.jobName" placeholder="任务名称" class="m-l-10 ell-input" :disabled="singlelineFlag"></el-input>
                            </el-form-item>
                        </el-row>
                    </el-row>
                     <el-row >
                        <el-row >
                             <el-form-item label="执行类型:" label-width="100px" >
                                <el-select v-model="editJobPlan.type" placeholder="执行类型" style="margin-right: 10px" class="m-l-10 el-input" @change="editchangeJobPlanType" :disabled="singlelineFlag">
                                    <el-option label="循环计划" value="1"></el-option>
                                    <el-option label="定时计划" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="消杀类型:" label-width="100px" >
                                <el-select v-model="editJobPlan.modeType" placeholder="消杀类型" style="margin-right: 10px" class="m-l-10 el-input" @change="editchangeJobModeType('edit')" :disabled="singlelineFlag">
                                    <el-option label="定点消杀" value="0"></el-option>
                                    <el-option label="全程消杀" value="1"></el-option>
                                    <el-option label="演示模式" value="2"></el-option>
                            </el-select>
                            </el-form-item>
                        </el-row>
                    </el-row>
                    <!--循环-->
                    <el-row v-if="editJobPlan.type=='1'">
                        <el-row  >
                            <el-form-item label="起始时间:" label-width="100px" >
                                <el-time-picker v-model="editJobPlan.startAndend" is-range range-separator="至" start-placeholder="开始时间" 
                                end-placeholder="结束时间" placeholder="选择时间范围" value-format="HH:mm" format='HH:mm' class="m-l-10" :disabled="singlelineFlag"/>
                            </el-form-item>
                         </el-row>
                         <el-row  >
                            <el-form-item  label="间隔时长:" label-width="100px" >
                                <el-select v-model="editJobPlan.interval" placeholder="请选择时长" style="width:60%" class="m-l-10" :disabled="singlelineFlag">
                                    <el-option v-for="item in editJobPlan.JobPlanSplitTime" :key="item.timeId" :label="item.label" :value="item.timeId" :disabled="item.disabled"  />
                                </el-select>
                            </el-form-item>
                          </el-row>
                    </el-row>
                    <!--定时-->
                    <el-row v-if="editJobPlan.type=='2'">
                        <el-row  >
                            <el-col :span="16">
                                <el-form-item  label="选择时间:" label-width="100px">
                                    <el-time-picker v-model="editJobPlan.selectValueStr" type="fixed-time" placeholder="选择时间" :picker-options="{selectableRange: '00:00:00 - 23:59:59'}" value-format="HH:mm" format='HH:mm' style="width:100%" class="m-l-10" :disabled="singlelineFlag" /> 
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" >
                                    <el-button type="primary" style="width:80px" vertical-align="middle" @click="editTimeClick()"  :disabled="singlelineFlag">添加</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="16">
                                <el-form-item  label="任务时间:" label-width="100px">
                                    <el-input v-model="editJobPlan.time" type="textarea" style="width:125%" :disabled="true" class="m-l-10"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                    <el-button type="primary" style="width:80px" vertical-align="middle" @click="editReduceTimeClick()" :disabled="singlelineFlag">删除</el-button>
                            </el-col>
                            
                         </el-row>
                    </el-row>
                    <!--执行周期-->
                    <el-row>
                        <el-row>
                                <el-checkbox :indeterminate="editJobPlan.isIndeterminate" v-model="editJobPlan.checkAll" @change="edithandleCheckAllChange" :disabled="singlelineFlag"><span style="font-size:18px;">全选</span></el-checkbox>
                                <div style="margin: 15px 0;"></div>
                                <el-checkbox-group v-model="editJobPlan.checkedWeekes" @change="handleCheckedcheckChange"  style="font-size:18px;" :disabled="singlelineFlag">
                                    <el-checkbox v-for="item in editJobPlan.labels" :label="item.value" :key="item.value"  >{{item.label}}</el-checkbox>
                                </el-checkbox-group>
                        </el-row>
                    </el-row>
                    <!--选择点-->
                    <el-row >
                        <div style="border-style:solid;border-width:1px;border-color:black;min-height:200px;margin-top: 20px">
                            <span style="font-size:20px;color:blue;">点位信息编辑</span>
                            <el-row>
                                <el-col :span="12" :push="1"> 
                                    <el-form-item label="工作类型:" label-width="100px" style="margin-top: 20px;"  v-if="editJobPlan.modeType=='0'" :disabled="singlelineFlag">
                                        <el-select v-model="editJobPlan.jobDetail.type" placeholder="请选择"  class="m-l-10 el-input" >
                                            <el-option label="消杀" value="1"></el-option>
                                            <el-option label="行走" value="0"></el-option>
                                            <el-option label="语音播报" value="2"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="工作类型:" label-width="100px" style="margin-top: 20px;"  v-if="editJobPlan.modeType !=='0'">
                                        <span style="font-size:18px;color:black;">行走</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                <el-form-item  label="工作时长:" label-width="100px" style="margin-top: 20px"  >
                                    <el-select v-model="editJobPlan.jobDetail.time" placeholder="请选择时长" class="m-l-10 el-input" :disabled="singlelineFlag">
                                        <el-option v-for="item in editJobPlan.jobDetailSplitTime" :key="item.timeId" :label="item.label" :value="item.timeId" :disabled="item.disabled"  />
                                    </el-select>
                                </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col  :span="12">                           
                                    <!-- <span style="font-size:18px;">编号:</span><el-input v-model="editJobPlan.jobDetail.goalId" disabled style="width:40%" class="m-l-10 "/> -->
                                    <el-form-item  label="编号:" label-width="100px"   >  
                                        <el-select v-model="editJobPlan.jobDetail.goalId" placeholder="请选择点位" style="margin-right: 50px"  class="m-l-10 el-input" >
                                            <el-option v-for="item in goalList" :key="item.id" :label="item.id" :value="item.id" :disabled="item.disabled"  />
                                        </el-select>
                                    </el-form-item> 
                                </el-col>
                              
                                <el-col :span="12"> 
                                    <!-- <span style="font-size:18px;">备注信息:</span><el-input v-model="editJobPlan.jobDetail.remarks" :disabled="singlelineFlag"  style="width:60%" class="m-l-10 "/> -->
                                     <el-form-item  label="信息:" label-width="100px"   >  
                                        <el-input v-model="editJobPlan.jobDetail.remarks"  style="width:100%" class="m-l-10 ell-input"/>
                                    </el-form-item>    
                                </el-col>
                               
                            </el-row>
                            <el-row>
                                <el-col :span="24" :push="16" >
                                    <el-button type="primary"   @click="addJobDetail('edit')" :disabled="singlelineFlag"> 添加点位任务</el-button>
                                    <el-button type="primary"   @click="editCleanJobDetail()" :disabled="singlelineFlag">重置</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-row>
                    <!--任务明细表格-->
                    <el-row>
                        <el-table :data="editJobPlan.jobdetailList" height="250" border style="width: 100%"   stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
                                <el-table-column prop="goalId" label="点位编号" width="80"></el-table-column>
                                <el-table-column prop="type" label="工作类型" width="80"> 
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.type==='0'"  >
                                            行走
                                        </span>
                                        <span v-if="scope.row.type==='1'" >
                                            消杀
                                        </span>
                                         <span v-if="scope.row.type==='2'" >
                                            语音播报
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="time" label="工作时长" width="150">
                                    <template slot-scope="scope" >
                                        <el-input v-model="scope.row.time" style="width:100px" class="ellll-input" @input.native="onInput0_300" :disabled="singlelineFlag" ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="remarks" label="备注信息" width="300">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.remarks!=='null'"  >
                                           {{scope.row.remarks}}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" prop="" width="80">
                                    <template slot-scope="scope"> 
                                        <!-- 删除按钮 -->
                                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false" >  
                                            <el-button type="danger" icon="el-icon-minus" size="mini" @click="editDeleteBygoalId(scope.row.goalId)" :disabled="singlelineFlag" ></el-button>
                                        </el-tooltip>
                                    </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editJobPlanDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="editJobPlanDialogData()" :disabled="singlelineFlag">确 定</el-button>
            </span>
        </el-dialog>

    </el-card >
  </div>
</template>

<script>

import { mapState } from 'vuex'
const weekOptions = [{ value: '1', label: '星期一' },{ value: '2', label: '星期二' },{ value: '3', label: '星期三' },{ value: '4', label: '星期四' },{ value: '5', label: '星期五' },{ value: '6', label: '星期六' },{ value: '7', label: '星期天' }] 
export default {
  name: 'machine',
  data(){
      return {
          jobPlanList:[],
          total:0,
          mapId:'',
          robotNo:'',
          multipleSelection:[],
          addJobPlanDialogVisible:false,
          addJobPlan:{
              startAndend:["00:00","23:59"],
              labels: weekOptions,
              isIndeterminate:false,
              checkAll:false,
              selectionArr:[],
              allElection:[],
              checkedWeekes:[],
              selectValueStr:null,
              selectTimeRange: {},
              time:'',
              interval:'',
              timeArray:[],
              jobName:'',
              type:'',
              modeType:'',
              JobPlanSplitTime: [{ timeId: 1, label: '1' }, { timeId: 5, label: '5' }, { timeId: 15, label: '15' }, { timeId: 30, label: '30' }, { timeId: 45, label: '45' }, { timeId: 60, label: '60' }, { timeId:75, label: '75' }, { timeId: 90, label: '90' }, { timeId: 120, label: '120' }],
              jobDetailSplitTime: [{ timeId: 0, label: '0' },{ timeId: 1, label: '1' }, { timeId: 5, label: '5' }, { timeId: 15, label: '15' }, { timeId: 30, label: '30' }, { timeId: 45, label: '45' }, { timeId: 60, label: '60' }, { timeId:75, label: '75' }, { timeId: 90, label: '90' }, { timeId: 120, label: '120' }
              , { timeId: 160, label: '160' }, { timeId: 210, label: '210' }, { timeId: 240, label: '240' }, { timeId: 270, label: '270' }, { timeId: 300, label: '300' }
              ],
              jobdetailList:[],
              jobDetail:{
                  goalId:'',
                  type:'',
                  remarks:'',
                  time:'',
              },
          },
          editJobPlan:{
              id:'',
              startAndend:"",
              labels: weekOptions,
              isIndeterminate:true,
              checkAll:false,
              selectionArr:[],
              allElection:[],
              checkedWeekes:[],
              selectValueStr:null,
              selectTimeRange: {},
              time:'',
              interval:'',
              modeType:'',
              timeArray:[],
              jobName:'',
              type:'',
              JobPlanSplitTime: [ { timeId: 5, label: '5' }, { timeId: 15, label: '15' }, { timeId: 30, label: '30' }, { timeId: 60, label: '60' }, { timeId: 90, label: '90' }, { timeId: 120, label: '120' }],
              jobDetailSplitTime: [{ timeId: 0, label: '0' },{ timeId: 1, label: '1' }, { timeId: 5, label: '5' }, { timeId: 15, label: '15' }, { timeId: 30, label: '30' }, { timeId: 45, label: '45' }, { timeId: 60, label: '60' }, { timeId:75, label: '75' }, { timeId: 90, label: '90' }, { timeId: 120, label: '120' }
              , { timeId: 160, label: '160' }, { timeId: 210, label: '210' }, { timeId: 240, label: '240' }, { timeId: 270, label: '270' }, { timeId: 300, label: '300' }
              ],
              jobdetailList:[],
              jobDetail:{
                  goalId:'',
                  type:'',
                  remarks:'',
                  time:'',
              },
          },
          goalList:[],
          mycanvasFlag:'',
          editJobPlanDialogVisible:false,
          drawingLineFlag:false,//暂停划线
          clickdown:false,
          dotList:[],
          drawingSufraceData:null,
          mapDate:null,
          imageWidth:'',
          imageHeight:'',
          resolution:'',
          origin_x:'',
          origin_y:'',
          globleX:'',
          globleY :'',
          gcanvas:null,
          executeFlag:false,
          singlelineFlag:true,
      }
  },
   computed: mapState([
    // 映射 this.count 为 store.state.count
    'mqttClient'
   ]),
   //生命周期函数
  created(){
    this.robotNo=this.$route.query.robotNo;
    this.mapId=this.$route.query.mapId;
    this.selectJobPlanList();
  },
  methods:{
        returnTaskMap(){
             this.$router.replace({path: '/taskMap?robotNo='+this.robotNo})
        },
        onInput0_300(e) {
            this.$message.closeAll();
            if (e.target.value < 1 || e.target.value > 300) {
                this.$message.warning("只能输入[1,300]区间的数");
            }
            e.target.value = (e.target.value >= 1 && e.target.value <= 300 && e.target.value.match(/^\d{1,3}(\.\d*)?$/)[0]) || null;
        },
        executeTask(){
            let selectionData=this.$refs.multipleTable.selection;
            this.executeFlag=false;
            if(selectionData.length>0){
                var dataIds=[]
                for (var i=0;i<selectionData.length;i++){ 
                        dataIds.push(selectionData[i].id) 
                }
                console.log(dataIds);
                if(selectionData.length==1){
                    this.$http.get('job/useJobPlans',{params :{ ids :  dataIds[0]+""}})
                    .then(response => {
                            if (response.data.code === 200) {
                                this.selectJobPlanList();
                                this.$message.success("执行成功!");
                                return
                            }else{
                                return this.$message.error(response.data.message);
                            }
                        }).catch(failResponse => {
                        
                    })
                    return 
                }
                if(selectionData.length>1){
                    //对比有没有交叉的计划
                    for (var i=0;i<selectionData.length-1;i++){ 
                        for (var j=i+1;j<selectionData.length;j++){ 
                            if(!this.executeFlag){
                                this.checkSelectionDataTime(selectionData[i],selectionData[j])
                            }else{
                                break;
                            }
                        }
                    }
                    if(!this.executeFlag){
                        this.$http.get('job/useJobPlans',{params :{ ids : dataIds.join(",")}})
                        .then(response => {
                                if (response.data.code === 200) {
                                    this.selectJobPlanList();
                                    this.$message.success("执行成功!");
                                    return
                                }else{
                                    return this.$message.error(response.data.message);
                                }
                            }).catch(failResponse => {
                            
                        })
                    }
                    return 
                }
            }else{
                this.$message.error("请选择要执行的任务计划!");
            }
        },
        time_to_sec(time) {
        　　if (time !== null) {
        　　　　var s = "";
        　　　　var hour = time.split(":")[0];
        　　　　var min = time.split(":")[1];
        　　　　var sec = time.split(":")[2];
        　　　　s = Number(hour * 3600) + Number(min * 60) + Number(sec);
        　　　　return s;
        　　}
        },
        //校验执行任务时函数
        checkSelectionDataTime(compareA,compareB){
           //校验是否同一天
           var weekA=compareA.week.split(',');
           var weekB=compareB.week.split(',');
           var flag =false;
           for(var i=0;i<weekA.length;i++){
                for(var j=0;j<weekB.length;j++){
                     if(weekA[i]==weekB[j]){
                        flag=true;
                        break;
                     }
                }
                if(flag){
                    break;
                }
           }
           if(!flag){
             return;
           }
           var tapeA= compareA.type;
           var tapeB= compareB.type;
           //循环
           if(tapeA=='1'&& tapeA==tapeB){
              var startTimeA=this.time_to_sec(compareA.startTime+":00")
              var startTimeB=this.time_to_sec(compareB.startTime+":00")
              var endTimeA  =this.time_to_sec(compareA.endTime+":00")
              var endTimeB  =this.time_to_sec(compareB.endTime+":00")
              //开始时间在A区间
              if(startTimeA <= startTimeB && startTimeB<=endTimeA ){
                    this.$message.error(compareA.jobName+" 与 "+compareB.jobName+"的循环区间重叠!");
                    this.executeFlag=true;
                    return
              }
              //结束时间在A区间
              if(startTimeA <= endTimeB && endTimeB<=endTimeA ){
                    this.$message.error(compareA.jobName+" 与 "+compareB.jobName+"的循环区间重叠!");
                    this.executeFlag=true;
                    return
              }
              //B包含A时间区间
              if(startTimeB <= startTimeA && endTimeB>=endTimeA ){
                    this.$message.error(compareA.jobName+" 与 "+compareB.jobName+"的循环区间重叠!");
                    this.executeFlag=true;
                    return
              }

           }
           //定时
           if(tapeA=='2'&& tapeA==tapeB){
               var timeA=compareA.time.split(',')
               var timeB=compareB.time.split(',')
               for (var i=0;i<timeA.length;i++){ 
                    for (var j=0;j<timeB.length;j++){ 
                          if(timeA[i]==timeB[j]){
                            this.$message.error(compareA.jobName+" 与 "+compareB.jobName+"的时刻"+timeA[i]+"重复!");
                            this.executeFlag=true;
                            break;
                        }
                    }
                    if(this.executeFlag){
                        break;
                    }
                }
                if(this.executeFlag){
                    return;
                }
                
           }
           //类型不等
           if(tapeA != tapeB){
                if(tapeA=='1'){
                    var startTimeA=this.time_to_sec(compareA.startTime+":00")
                    var endTimeA  = this.time_to_sec(compareA.endTime+":00")
                    var timeB=compareB.time.split(',')
                    for(var i=0;i<timeB.length;i++){
                        if(startTimeA <=this.time_to_sec(timeB[i]+":00") && endTimeA >=this.time_to_sec(timeB[i]+":00")  ){
                            this.$message.error(compareA.jobName+" 与 "+compareB.jobName+"的时刻"+timeB[i]+"重复!");
                            this.executeFlag=true;
                            break;
                        }
                    }
                    if(this.executeFlag){
                        return;
                    }
                    
                }else{
                    var startTimeB=this.time_to_sec(compareB.startTime+":00")
                    var endTimeB  = this.time_to_sec(compareB.endTime+":00")
                    var timeA=compareA.time.split(',')
                    for(var i=0;i<timeA.length;i++){
                        if(startTimeB <=this.time_to_sec(timeA[i]+":00") && endTimeB >=this.time_to_sec(timeA[i]+":00")  ){
                            this.$message.error(compareA.jobName+" 与 "+compareB.jobName+"的时刻"+timeA[i]+"重复!");
                            this.executeFlag=true;
                            break;
                        }
                    }
                    if(this.executeFlag){
                        return;
                    }
                }

           }


        },
        editJobPlanDialogData(){
            if(this.editJobPlan.jobName==''){
                this.$message.error("请输入任务名称!");
                return
            }
            if(this.editJobPlan.type==''){
                this.$message.error("请选择任务类型!");
                  return
            }
            if(this.editJobPlan.modeType==''){
                this.$message.error("请选择消杀类型!");
                  return
            }
            let startTime='';
            let endTime='';
            let interval='';
            if(this.editJobPlan.type=='1' && this.editJobPlan.startAndend.length <1){
                this.$message.error("请选择循环任务时间段!");
                return
            }else if(this.editJobPlan.type=='1' && this.editJobPlan.startAndend.length >1){
                startTime=this.editJobPlan.startAndend[0];
                endTime=this.editJobPlan.startAndend[1];
                interval=this.editJobPlan.interval;
            }
            let time='';
            if(this.editJobPlan.type=='2' && this.editJobPlan.time==''){
                this.$message.error("请选择定时开启时间!");
                return
            }else  if(this.editJobPlan.type=='2' && this.editJobPlan.time !=''){
                time=this.editJobPlan.time;
            }
            if(this.editJobPlan.checkedWeekes.length<0){
                this.$message.error("请选择执行周期!");
                return
            }
            if(this.editJobPlan.jobdetailList.length==0){
                 this.$message.error("请添加任务!");
                 return
            }
            for(var i=0;i<this.editJobPlan.jobdetailList.length;i++){
                if (this.editJobPlan.jobdetailList[i].time==undefined ||this.editJobPlan.jobdetailList[i].time=='') {
                    this.$message.error("请补全点位编号为"+this.editJobPlan.jobdetailList[i].goalId+"任务明细执行时长!");
                    return
                }
            }
            let editPlanJob={id:this.editJobPlan.id,robotNo:this.robotNo,mapId: this.mapId,jobName:this.editJobPlan.jobName,type:this.editJobPlan.type,modeType:this.editJobPlan.modeType
            ,startTime:startTime,endTime:endTime,interval:interval,time:time,week:this.editJobPlan.checkedWeekes.join(','),jobDetails:this.editJobPlan.jobdetailList
            }; 
            this.$http.post('/job/editJobPlan',JSON.stringify(editPlanJob)) .then(response => {
                if (response.data.code === 200) {
                   this.$message.success("更新成功!");
                   this.editJobPlanDialogVisible=false;
                   this.selectJobPlanList();
                   return
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
            })
        },
        editJobPlanDialogClose(){
            this.editClearCanvas()
            this.editJobPlan.jobName=''
            this.editJobPlan.type=''
            this.editchangeJobPlanType(1);
             //清除划线
            //this.restoreDrawingSurface(this.gcanvas.getContext('2d'))
            this.drawingLineFlag=false
            //清除点位信息
            this.editJobPlan.jobDetail.type=''
            this.editJobPlan.jobDetail.time=''
            this.editJobPlan.jobDetail.goalId=''
            // this.editJobPlan.jobDetail.goalName=''
            // this.editJobPlan.jobDetail.goalYaw=''
            this.editJobPlan.jobDetail.remarks=''
            this.editJobPlan.jobdetailList=[]
            this.editJobPlan.checkedWeekes=[]
            this.gcanvas=null;
            this.editJobPlan.isIndeterminate = false;
            this.singlelineFlag=true;
            this.goalList=[];
        },
         //编辑
        editById(obj){
            this.$http.get('/job/findJobPlanInfo',{params :{ id : obj }}) .then(response => {
                if (response.data.code === 200) {
                    this.editJobPlanDialogVisible=true;
                    let obj =response.data.result
                    this.editJobPlan.id=obj.id
                    this.editJobPlan.jobName=obj.jobName
                    this.editJobPlan.modeType=obj.modeType
                    this.editJobPlan.type=obj.type
                    if('1'==obj.type){
                        this.editJobPlan.startAndend=[obj.startTime,obj.endTime];
                        this.editJobPlan.interval=obj.interval;
                    }else{
                        this.editJobPlan.time=obj.time
                        this.editJobPlan.timeArray=obj.time.split(',')
                    }
                    this.editJobPlan.checkedWeekes=obj.week.split(',')
                    this.editJobPlan.jobdetailList=obj.jobDetails
                   return
                }else{
                    this.$message.error("数据被更改,重新加载数据......");
                    return location.reload();
                }
                }).catch(failResponse => {
            })
            this.$http.get('map/findMapById',{params :{ mapId : this.mapId }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.mycanvasFlag='edit';
                        this.mapDate=response.data.result
                        this.downloadOFile(this.mapDate.orginUrl,this.mapDate,"editmycanvas");
                        return
                    }else{
                        //this.singlelineFlag=true //单线标记
                        console.log("未查询到地图!")
                    }
                }).catch(failResponse => {
                
            })
        },
        //添加数据if()
        addJobPlanDialogData(){
            if(this.addJobPlan.jobName==''){
                this.$message.error("请输入任务名称!");
                return
            }
            if(this.addJobPlan.type==''){
                this.$message.error("请选择任务类型!");
                return
            }
            if(this.addJobPlan.modeType==''){
                this.$message.error("请选择消杀类型!");
                return
            }
            let startTime='';
            let endTime='';
            let interval='';
            if(this.addJobPlan.type=='1' && this.addJobPlan.startAndend.length <1){
                this.$message.error("请选择循环任务时间段!");
                return
            }else if(this.addJobPlan.type=='1' && this.addJobPlan.startAndend.length >1){
                startTime=this.addJobPlan.startAndend[0];
                endTime=this.addJobPlan.startAndend[1];
                interval=this.addJobPlan.interval;
            }
            let time='';
            if(this.addJobPlan.type=='2' && this.addJobPlan.time==''){
                this.$message.error("请选择定时开启时间!");
                return
            }else  if(this.addJobPlan.type=='2' && this.addJobPlan.time !=''){
                time=this.addJobPlan.time;
            }
            if(this.addJobPlan.checkedWeekes.length<0){
                 this.$message.error("请选择执行周期!");
                 return
            }
            if(this.addJobPlan.jobdetailList.length==0){
                 this.$message.error("请添加任务!");
                 return
            }
            for(var i=0;i<this.addJobPlan.jobdetailList.length;i++){
                if (this.addJobPlan.jobdetailList[i].time==undefined ||this.addJobPlan.jobdetailList[i].time=='') {
                    this.$message.error("请补全点位编号为"+this.addJobPlan.jobdetailList[i].goalId+"任务明细执行时长!");
                    return
                }
            }
            let newPlanJob={robotNo:this.robotNo,mapId: this.mapId,jobName:this.addJobPlan.jobName,type:this.addJobPlan.type,modeType:this.addJobPlan.modeType
            ,startTime:startTime,endTime:endTime,interval:interval,time:time,week:this.addJobPlan.checkedWeekes.join(','),jobDetails:this.addJobPlan.jobdetailList
            }; 
            
            this.$http.post('/job/addJobPlan',JSON.stringify(newPlanJob)) .then(response => {
                if (response.data.code === 200) {
                   this.$message.success("保存成功!");
                   this.selectJobPlanList();
                   this.addJobPlanDialogVisible=false;
                   return
                }else{
                     return this.$message.error(response.data.message);
                }
                }).catch(failResponse => {
            })
        },
        //关闭框
        addJobPlanDialogClose(){
            this.clearCanvas()
            this.addJobPlan.jobName=''
            this.addJobPlan.type=''
            this.addJobPlan.modeType=''
            this.changeJobPlanType(1);
             //清除划线
            //this.restoreDrawingSurface(this.gcanvas.getContext('2d'))
            this.drawingLineFlag=false
            //清除点位信息
            this.addJobPlan.jobDetail.type=''
            this.addJobPlan.jobDetail.time=''
            this.addJobPlan.jobDetail.goalId=''
            this.addJobPlan.jobDetail.remarks=''
            // this.addJobPlan.jobDetail.goalName=''
            // this.addJobPlan.jobDetail.goalYaw=''
            this.addJobPlan.jobdetailList=[]
            this.addJobPlan.checkedWeekes=[]
            this.gcanvas=null;
            this.addJobPlan.isIndeterminate = false;
            this.goalList=[]
        },
        clearCanvas(){
            var c=document.getElementById("addmycanvas");
            if(c==undefined){
                return;
            }
            var cxt=c.getContext("2d");
            cxt.clearRect(0,0,c.width,c.height);
        },
        editClearCanvas(){
            var c=document.getElementById("editmycanvas");
            if(c==undefined){
                return;
            }
            var cxt=c.getContext("2d");
            cxt.clearRect(0,0,c.width,c.height);
        },
        deleteBygoalId(obj){
            for (var i = 0; i < this.addJobPlan.jobdetailList.length; i++) {
                    if(obj==this.addJobPlan.jobdetailList[i].goalId){
                        this.addJobPlan.jobdetailList.splice(i, 1);
                        return;
                    }
            }
        },
        editDeleteBygoalId(obj){
            for (var i = 0; i < this.editJobPlan.jobdetailList.length; i++) {
                    if(obj==this.editJobPlan.jobdetailList[i].goalId){
                        this.editJobPlan.jobdetailList.splice(i, 1);
                        return;
                    }
            }
        },
        cleanJobDetail(){
             //清除划线
            //this.restoreDrawingSurface(this.gcanvas.getContext('2d'))
            this.drawingLineFlag=false
            //清除点位信息
            this.addJobPlan.jobDetail.type=''
            this.addJobPlan.jobDetail.time=''
            this.addJobPlan.jobDetail.goalId=''
            this.addJobPlan.jobDetail.remarks=''
            // this.addJobPlan.jobDetail.goalName=''
            // this.addJobPlan.jobDetail.goalYaw=''
        },
        editCleanJobDetail(){
             //清除划线
           // this.restoreDrawingSurface(this.gcanvas.getContext('2d'))
            this.drawingLineFlag=false
            //清除点位信息
            this.editJobPlan.jobDetail.type=''
            this.editJobPlan.jobDetail.time=''
            this.editJobPlan.jobDetail.goalId=''
            this.editJobPlan.jobDetail.remarks=''
            // this.editJobPlan.jobDetail.goalName=''
            // this.editJobPlan.jobDetail.goalYaw=''
        },

        //添加点位工作任务
        addJobDetail(obj){
            let jobPlan=null;
            if("add"==obj){
                jobPlan=this.addJobPlan
            }else{
                 jobPlan=this.editJobPlan
            }
            if(jobPlan.modeType==undefined || jobPlan.modeType==''){
                return this.$message.error("请选择消杀类型!");
            }
            if(jobPlan.modeType !=='0'){
               jobPlan.jobDetail.type='0'
            }
            if(jobPlan.jobDetail.type==undefined || jobPlan.jobDetail.type==''){
                return this.$message.error("请选择点位工作类型!");
            }
           
            if(jobPlan.jobDetail.time==undefined || jobPlan.jobDetail.time==''){
                return this.$message.error("请选择点位工作时长!");
            }
            if(jobPlan.jobDetail.goalId===undefined || jobPlan.jobDetail.goalId===''){
                return this.$message.error("请在地图中选择执行任务点目标!");
            }
            for (var i = 0; i < jobPlan.jobdetailList.length; i++) {
                    if(jobPlan.jobDetail.goalId==jobPlan.jobdetailList[i].goalId){
                        this.$message.error("该目标点编辑任务已存在!");
                        return;
                    }
            }
            let jobDetailinfo={type:"",time:"",goalId:"",remarks:""};
            jobDetailinfo.time =jobPlan.jobDetail.time
            jobDetailinfo.goalId=jobPlan.jobDetail.goalId
            jobDetailinfo.remarks=jobPlan.jobDetail.remarks
            jobDetailinfo.type=jobPlan.jobDetail.type
            jobPlan.jobdetailList.push(jobDetailinfo)
            //清除划线
            this.restoreDrawingSurface(this.gcanvas.getContext('2d'))
            this.drawingLineFlag=false
            //清除点位信息
            jobPlan.jobDetail.type=''
            jobPlan.jobDetail.time=''
            jobPlan.jobDetail.goalId=''
            jobPlan.jobDetail.goalName=''
            jobPlan.jobDetail.goalYaw=''
            jobPlan.jobDetail.remarks=''
        },
        
        addTimeClick(){
             //剔除重复的时间
            if (this.addJobPlan.selectValueStr !== null && this.addJobPlan.selectValueStr.split(' ').join('').length !== 0) {
                    for (var i = 0; i < this.addJobPlan.timeArray.length; i++) {
                    if (this.addJobPlan.timeArray[i] === this.addJobPlan.selectValueStr) {
                        return this.$message.error("该时间已存在!");
                    }
                }
                this.addJobPlan.timeArray.push(this.addJobPlan.selectValueStr)
                console.log(this.addJobPlan.timeArray)
                this.setTimeInterval()
            }else{
                return this.$message.error("请选时间!");
            }
        },
        editTimeClick(){
             //剔除重复的时间
            if (this.editJobPlan.selectValueStr !== null && this.editJobPlan.selectValueStr.split(' ').join('').length !== 0) {
                    for (var i = 0; i < this.editJobPlan.timeArray.length; i++) {
                    if (this.editJobPlan.timeArray[i] === this.editJobPlan.selectValueStr) {
                        return this.$message.error("该时间已存在!");
                    }
                }
                this.editJobPlan.timeArray.push(this.editJobPlan.selectValueStr)
                console.log(this.editJobPlan.timeArray)
                this.setEditTimeInterval()
            }else{
                return this.$message.error("请选时间!");
            }
        },
         // 拼接时间段值
        setTimeInterval() {
            this.addJobPlan.time = ''
            for (var i = 0; i < this.addJobPlan.timeArray.length; i++) {
                if (i < this.addJobPlan.timeArray.length - 1) {
                        this.addJobPlan.time = this.addJobPlan.time + this.addJobPlan.timeArray[i] + ','
                } else {
                        this.addJobPlan.time = this.addJobPlan.time + this.addJobPlan.timeArray[i]
                }
            }
        },
        //删除时间段
        reduceTimeClick(){
            if (this.addJobPlan.timeArray.length > 0) {
                this.addJobPlan.timeArray.pop()
                this.setTimeInterval()
            }
        },
         //删除时间段
        editReduceTimeClick(){
            if (this.editJobPlan.timeArray.length > 0) {
                this.editJobPlan.timeArray.pop()
                this.setEditTimeInterval()
            }
        },
        //全选
        handleCheckAllChange(val) {
            this.addJobPlan.checkedWeekes = val ? ['1','2','3','4','5','6','7'] : [];
            this.addJobPlan.isIndeterminate = false;
        },
        edithandleCheckAllChange(val) {
            this.editJobPlan.checkedWeekes = val ? ['1','2','3','4','5','6','7'] : [];
            this.editJobPlan.isIndeterminate = false;
        },
        handleCheckedcheckChange(value){
            let checkedCount = value.length;
            this.addJobPlan.checkAll = checkedCount === this.addJobPlan.labels.length;
            this.addJobPlan.isIndeterminate = checkedCount > 0 && checkedCount < this.addJobPlan.labels.length;
        },
        //切换类型处理
        changeJobPlanType(val){
            this.addJobPlan.selectValueStr=null
            this.addJobPlan.timeArray=[]
            this.addJobPlan.time==''
            this.setTimeInterval()
            this.addJobPlan.startAndend=["00:00","23:59"]
            this.addJobPlan.interval=''
        },
        //编辑方法
        editchangeJobPlanType(val){
            this.editJobPlan.selectValueStr=null
            this.editJobPlan.timeArray=[]
            this.editJobPlan.time==''
            this.setEditTimeInterval()
            this.editJobPlan.startAndend=["00:00","23:59"]
            this.editJobPlan.interval=''
        },
        editchangeJobModeType(obj){
            var JobPlan=null;
            if(obj=='edit'){
                JobPlan=this.editJobPlan
            }else{
                JobPlan=this.addJobPlan
            }
            if(JobPlan.modeType !== 0){
                
                for (var i = 0; i < JobPlan.jobdetailList.length; i++) {
                    JobPlan.jobdetailList[i].type='0';
                }
            }
        },
         // 拼接时间段值
        setEditTimeInterval() {
            this.editJobPlan.time = ''
            for (var i = 0; i < this.editJobPlan.timeArray.length; i++) {
                if (i < this.editJobPlan.timeArray.length - 1) {
                        this.editJobPlan.time = this.editJobPlan.time + this.editJobPlan.timeArray[i] + ','
                } else {
                        this.editJobPlan.time = this.editJobPlan.time + this.editJobPlan.timeArray[i]
                }
            }
        },
        //打开添加对话框
        openAddJobPlanDialogVisible(){
            if(this.jobPlanList.length>10){
                return this.$message.error("任务个数不能超过10个!");
            }
            this.$http.get('map/findMapById',{params :{ mapId : this.mapId }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.mapDate=response.data.result
                        this.mycanvasFlag='add';
                        this.downloadOFile(this.mapDate.orginUrl,this.mapDate,"addmycanvas");
                        this.addJobPlanDialogVisible=true;
                        return
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })
        },
        //删除
        deleteById(obj){
            this.$http.get('job/deleteJobPlans',{params :{ jobPlanId : obj }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.$message.success("删除成功!");
                        this.selectJobPlanList();
                        return
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })
        },
        handleSelectionChange(val){
            this.multipleSelection=val
        },
        //返回页面
        returnMissionRobot(){
              this.$router.replace({path: '/missionPlanning'})
        },
        selectJobPlanList(){
            let that=this
            this.$http.get('job/selectJobPlans',{params :{ robotNo : this.robotNo,mapId : this.mapId }})
            .then(response => {
                    if (response.data.code === 200) {
                        that.jobPlanList=response.data.result


                        that.$nextTick(() => {
                           that.jobPlanList.forEach(item => {
                            if (item.state === '1') {
                                console.log("------------");
                                that.$refs.multipleTable.toggleRowSelection(item);
                            }
                        })
                        });
                        
                        return
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {
                
            })

       },
      
       // 下载原点文件
       downloadOFile(url,dataMap,mycanva) {
        console.log('下载原点文件', url)
         this.$http.get(window.location.origin+url)
            .then(res => {
                const blob = new Blob([res.data])
                const reader = new FileReader()
                const that = this
                reader.readAsText(blob, 'utf-8')
                reader.onload = function() {
                console.log(reader.result)
                that.resolution = reader.result.substring(reader.result.indexOf('resolution:') + 'resolution:'.length, reader.result.indexOf('origin:'))
                var tempOrigin = reader.result.substring(reader.result.indexOf('[') + 1, reader.result.indexOf(']'))
                console.log(tempOrigin)
                var originArr = tempOrigin.split(',')
                that.origin_x = originArr[0]
                that.origin_y = originArr[1]
                console.log(dataMap.mapPngUrl)
                that.doDraw(dataMap.mapPngUrl,dataMap,mycanva)
            }  
            }).catch(res => {
                
            })
        },
         // imageUrl为后台提供图片地址
        doDraw(imageUrl,dataMap,mycanva) {
            // 获取canvas
            var canvas = document.getElementById(mycanva)
            // 由于弹窗，确保已获取到
            var a = setInterval(() => {
            // 重复获取
                canvas = document.getElementById(mycanva)
                if (!canvas) {
                    return false
                } else {
                clearInterval(a)
                // 可以理解为一个画笔，可画路径、矩形、文字、图像
                var context = canvas.getContext('2d')
                var scale = window.devicePixelRatio
                context.scale(scale, scale)
                var img = new Image()
                img.src = imageUrl
                const that = this
                // 加载图片
                img.onload = function() {
                    if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    canvas.setAttribute('width', img.width)
                    canvas.setAttribute('height', img.height)
                    that.imageWidth = canvas.width
                    that.imageHeight = canvas.height
                    that.gcanvas = canvas
                    // 绘制图片
                    context.drawImage(img, 0, 0, img.width, img.height)
                    //起始点坐标计算公式
                    var x1 = (0 - that.origin_x) / that.resolution
                    var y1 = that.imageHeight - (0 - that.origin_y) / that.resolution
                    //画出原点坐标
                    that.doDrawLine(context, x1 - 10, y1, x1 + 10, y1, 'red', 2)
                    that.doDrawLine(context, x1, y1 - 10, x1, y1 + 10, 'red', 2)
                    //画轨迹
                    that.downloadRoadFile(dataMap.roadUrl,dataMap)
                    }
                  }
                   //定义鼠标
                    var mousedown
                    canvas.onmousedown = function(ev) {
                        var rect = canvas.getBoundingClientRect()
                        var x = (ev.x - rect.left) * (canvas.width / rect.width)
                        var y = (ev.y - rect.top) * (canvas.height / rect.height)
                        //获取鼠标坐标
                        mousedown = { x, y }
                        console.log(mousedown)
                        if(!that.drawingLineFlag){
                            that.findGoal(x, y)
                        }
                        // //清除橡皮线
                        // that.saveDrawingSurface(context)
                    }
                    //  //获取角度
                    // canvas.onmousemove = function(ev) {
                    //     if (that.clickdown) {
                    //         var rect = canvas.getBoundingClientRect()
                    //         var x1 = (ev.x - rect.left) * (canvas.width / rect.width)
                    //         var y1 = (ev.y - rect.top) * (canvas.height / rect.height)
                    //         var loc = { x1, y1 }
                    //         if(that.mycanvasFlag=='edit'){
                    //             //角度
                    //             that.editJobPlan.jobDetail.angle = Math.atan2((y1 - mousedown.y), (x1 - mousedown.x))
                    //             //弧度
                    //             that.editJobPlan.jobDetail.goalYaw = (that.editJobPlan.jobDetail.angle / Math.PI * 180).toFixed(2)
                    //         }else if(that.mycanvasFlag='add'){
                    //              //角度
                    //             that.addJobPlan.jobDetail.angle = Math.atan2((y1 - mousedown.y), (x1 - mousedown.x))
                    //             //弧度
                    //             that.addJobPlan.jobDetail.goalYaw = (that.addJobPlan.jobDetail.angle / Math.PI * 180).toFixed(2)
                    //         }
                    //         that.restoreDrawingSurface(context)
                    //         that.drawingLine(context, loc, mousedown)
                    //     }
                    // }
                    // canvas.onmouseup = function(ev) {
                    //     console.log("------clickdown")
                    //     that.clickdown = false
                    // }
                }
            }, 10)
        },
        // 绘图表面的保存
        saveDrawingSurface(context) {
            console.log("---saveDrawingSurface")
            var that = this
            that.drawingSufraceData = context.getImageData(0, 0, this.imageWidth, this.imageHeight)
        },
         //绘图表面与恢复
        restoreDrawingSurface(context) {
            var that = this
            //console.log("---restoreDrawingSurface")
            if(that.drawingSufraceData!=null){
                context.putImageData(that.drawingSufraceData, 0, 0)
            }
        },
        // 查找点击的目标点
        findGoal(x, y) {
            var that = this
            for (var i = 0; i < this.dotList.length; i++) {
                    var x1 = parseFloat(this.dotList[i].X)
                    var y1 = parseFloat(this.dotList[i].Y)
                    var gId = parseInt(this.dotList[i].Id)
                    x1 = (x1 - this.origin_x) / this.resolution
                    y1 = this.imageHeight - (y1 - this.origin_y) / this.resolution
                    if (Math.abs(x - x1) < 3 && Math.abs(y - y1) < 3) {
                        that.drawingLineFlag=true;
                        if(that.mycanvasFlag=='edit'){
                            that.editJobPlan.jobDetail.goalId = gId
                        }else if(that.mycanvasFlag=='add'){
                            that.addJobPlan.jobDetail.goalId = gId
                        }
                        that.clickdown = true
                        break
                    }
            }
        },
         // 橡皮筋画线
        drawingLine(context, loc, ev) {
            context.beginPath()
            context.moveTo(ev.x, ev.y)
            context.lineTo(loc.x1, loc.y1)
            context.stroke()
        },
        // 画线doDra
        doDrawLine(context, x1, y1, x2, y2, color, line) {
        context.beginPath()
        context.moveTo(x1, y1)
        context.lineTo(x2, y2)
        context.strokeStyle = color
        context.lineWidth = line
        context.stroke()
        },
        //根据轨迹文件画图
        downloadRoadFile(url,dataMap) {
            console.log('加载xml文件')
            this.$http.get(window.location.origin+url)
                .then(res => {
                        const blob = new Blob([res.data])
                        const reader = new FileReader()
                        const that = this
                        reader.readAsText(blob, 'utf-8')
                        reader.onload = function() {
                        var map = that.$x2js.xml2js(reader.result)  
                        var xmlList = map.map.vertex
                        var lineXmlList = map.map.edge
                        var tempList = []
                        var lineist = []
                        for (var i = 0; i < xmlList.length; i++) {
                            var tempString = xmlList[i]
                            var Id =tempString._id
                            var id=Id*1
                            var X =tempString._x
                            var Y =tempString._y
                            that.goalList.push({ id, X, Y })
                            tempList.push({ Id, X, Y })
                            console.log(that.goalList)
                        }
                        if(lineXmlList.length===undefined){
                            var lineString = lineXmlList
                            var lid = lineString._id
                            var src_id = lineString._src_id
                            var dst_id = lineString._dst_id
                            lineist.push({ lid, src_id, dst_id })
                        }else{
                            for (var k = 0; k < lineXmlList.length; k++) {
                                var lineString = lineXmlList[k]
                                var lid = lineString._id
                                var src_id = lineString._src_id
                                var dst_id = lineString._dst_id
                                lineist.push({ lid, src_id, dst_id })
                            }
                        }
                        
                        dataMap.dotList = tempList
                        that.dotList=tempList
                        dataMap.lineList = lineist
                        for (var j = 0; j < lineist.length; j++) {
                            var context = that.gcanvas.getContext('2d')
                            // var scale = window.devicePixelRatio
                            // context.scale(scale, scale)
                            var m = parseInt(lineist[j].src_id)
                            var n = parseInt(lineist[j].dst_id)
                            var x = parseFloat(dataMap.dotList[m].X)
                            var y = parseFloat(dataMap.dotList[m].Y)
                            x = (x - that.origin_x) / that.resolution
                            y = that.imageHeight - (y - that.origin_y) / that.resolution
                            var x2 = parseFloat(dataMap.dotList[n].X)
                            var y2 = parseFloat(dataMap.dotList[n].Y)
                            x2 = (x2 - that.origin_x) / that.resolution
                            y2 = that.imageHeight - (y2 - that.origin_y) / that.resolution
                            that.doDrawLine(context, x, y, x2, y2, 'blue', 2)
                        }
                        for (var l = 0; l < tempList.length; l++) {
                            var context1 = that.gcanvas.getContext('2d')
                            // var scale1 = window.devicePixelRatio
                            // context1.scale(scale1, scale1)
                            var x1 = parseFloat(dataMap.dotList[l].X)
                            var y1 = parseFloat(dataMap.dotList[l].Y)
                            x1 = (x1 - that.origin_x) / that.resolution
                            y1 = that.imageHeight - (y1 - that.origin_y) / that.resolution
                            that.doDrawSicle(context1, x1, y1, 'green', 3,l)
                        }
                    
                    }
                }).catch((error) => {
                    console.log(error)
                })
            },
        //机器人原点
        doDrawSiclePath(context, x, y, color, line) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },
        // 画大圆点
        doDrawSicle(context, x, y, color, line,index) {
            context.beginPath()
            context.arc(x, y, line / 2, 2 * Math.PI, 0, true)
            context.lineWidth = line
            context.strokeStyle = color
            context.shadowOffsetX = 0
            context.shadowOffsetY = 0
            context.font="15px lighter arial";
            context.fillText(index,x,y);
            context.shadowColor = color
            context.shadowBlur = 0
            context.stroke()
        },

  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.els-input {
    width: 120px;
}
.elll-input {
    width: 100px;
}
.ellll-input {
    width: 80px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}
.m-l-20 {
  margin-left: 20px !important;
}
.m-l-10 {
  margin-left: 10px !important;
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
.el-form-item{
    display: inline-block;
    margin-right: 40px;
    vertical-align: top;
    font-size: 20px;
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}




</style>


// WEBPACK FOOTER //
// src/components/robot/Task.vue